/**
 * Route for `igaming-license-specific-dashboards-mga-cura-ao-lo`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingLicenseSpecificDashboardsMgaCuraAoLoPage } from "../features/igaming-license-specific-dashboards-mga-cura-ao-lo/IgamingLicenseSpecificDashboardsMgaCuraAoLoPage";

export const igamingLicenseSpecificDashboardsMgaCuraAoLoRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-license-specific-dashboards-mga-cura-ao-lo",
	component: IgamingLicenseSpecificDashboardsMgaCuraAoLoPage,
});

export default igamingLicenseSpecificDashboardsMgaCuraAoLoRoute;
